import { PurchaseWithItems } from "@/types";
import TableHeader from "../TableHeader";
import TableRow from "../TableRow";

export default function PurchasesTable({
  dbPurchaseData,
}: {
  dbPurchaseData: PurchaseWithItems[];
}) {
  return dbPurchaseData.length === 0 ? (
    <div className="text-xs">No purchases to show</div>
  ) : (
    <div className="">
      <TableHeader table="purchases" />

      <div className="rounded-b-sm border">
        {dbPurchaseData.map((data, index) => (
          <TableRow key={data.id} data={data} table="purchases" index={index} />
        ))}
      </div>
    </div>
  );
}
